import { SEARCH } from './mutation-types'
import { detachListener } from './firebaseListeners'
import contacts from '../contact/addressbook-short.json'

const rebuildDeliveriesIndex = (deliveries) => {
  const indexByKey = {}
  deliveries.forEach((delivery, index) => {
    if (delivery && delivery['.key']) {
      indexByKey[delivery['.key']] = index
    }
  })
  return indexByKey
}

export default {
  setUser (state, value) {
    state.user = value
  },
  setUserInfo (state, value) {
    state.userInfo = value
  },
  setUserLang (state, value) {
    state.userInfo.language = value
  },
  setIsZoneVerification (state, value) {
    state.userInfo.isZoneVerification = value
  },
  setFuelCharge (state, value) {
    state.fuelCharge = value
  },
  clearUser (state) {
    state.user = false
    state.userInfo = false
    state.authorization = null
    state.primaryAuthorization = null
    state.availableCompanies = []
  },
  initAllContact (state) {
    state.allContacts = contacts
  },
  clearContacts (state) {
    state.allContacts = {}
  },
  [SEARCH.STORE] (state, search) {
    state.search = search
  },
  [SEARCH.STORE_FIELD] (state, search) {
    state.searchFields = search
  },
  [SEARCH.CLEAR] (state) {
    state.search = null
    state.searchFields = {}
    state.searchLastPage = 0
  },
  [SEARCH.SET_LAST_PAGE] (state, page) {
    state.searchLastPage = page
  },
  setAuthorization (state, payload) {
    state.authorization = payload
  },
  setPrimaryAuthorization (state, payload) {
    state.primaryAuthorization = payload
  },
  setAvailableCompanies (state, payload) {
    state.availableCompanies = Array.isArray(payload) ? payload : []
  },
  setCompanyUpdateSeen (state, payload) {
    if (!payload || !payload.companyUID) return

    if (state.authorization && state.authorization.company === payload.companyUID) {
      state.authorization.isUpdateSeen = payload.isUpdateSeen
    }

    state.availableCompanies = state.availableCompanies.map(company => {
      if (company.uid !== payload.companyUID) return company
      return {
        ...company,
        isUpdateSeen: payload.isUpdateSeen
      }
    })

    if (!state.primaryAuthorization) return
    if (state.primaryAuthorization.company === payload.companyUID) {
      state.primaryAuthorization.isUpdateSeen = payload.isUpdateSeen
      return
    }

    if (
      state.primaryAuthorization.sisterCompanies &&
      state.primaryAuthorization.sisterCompanies[payload.companyUID]
    ) {
      state.primaryAuthorization.sisterCompanies[payload.companyUID].isUpdateSeen = payload.isUpdateSeen
    }
  },
  setChatMessages (state, messages) {
    state.chatMessages = messages
  },
  updateDashboardFilterDateRange (state, payload) {
    state.dashboardFilterData.dateRange = payload
  },
  updateDashboardFilterOrderStatuses (state, payload) {
    state.dashboardFilterData.filteredOrderStatuses = payload
  },
  updateDashboardZoneSelectedParam (state, payload) {
    state.dashboardFilterData.selectedZoneParam = payload
  },
  updateDashboardFilteredZones (state, payload) {
    state.dashboardFilterData.filteredZones = payload
  },
  updateDashboardhighlightedRow (state, payload) {
    state.dashboardFilterData.highlightedRow = payload
  },
  setMarketplaceAlerts (state, payload) {
    state.alerts.marketplace = payload
  },
  setFeatureFlags (state, payload) {
    state.featureFlags = payload
  },
  setDeliveries (state, deliveries) {
    state.deliveries = deliveries
    state.deliveriesIndexByKey = rebuildDeliveriesIndex(deliveries)
  },
  upsertDeliveriesBatch (state, deliveries) {
    if (!Array.isArray(deliveries) || !deliveries.length) return

    deliveries.forEach((delivery) => {
      if (!delivery || !delivery['.key']) return

      const key = delivery['.key']
      const existingIndex = state.deliveriesIndexByKey[key]

      if (typeof existingIndex === 'number') {
        state.deliveries.splice(existingIndex, 1, delivery)
      } else {
        state.deliveries.push(delivery)
        state.deliveriesIndexByKey[key] = state.deliveries.length - 1
      }
    })
  },
  removeDeliveriesBatch (state, keys) {
    if (!Array.isArray(keys) || !keys.length) return

    const toRemove = new Set(keys)
    state.deliveries = state.deliveries.filter(delivery => !toRemove.has(delivery['.key']))
    state.deliveriesIndexByKey = rebuildDeliveriesIndex(state.deliveries)
  },
  setDeliveriesLoaded (state, loaded) {
    state.deliveriesLoaded = loaded
  },
  clearDeliveries (state) {
    state.deliveries = []
    state.deliveriesIndexByKey = {}
    state.deliveriesLoaded = false
    detachListener('deliveries')
  },
  setZones (state, zones) {
    state.zones = zones
  },
  setZonesLoaded (state, loaded) {
    state.zonesLoaded = loaded
  },
  clearZones (state) {
    state.zones = []
    state.zonesLoaded = false
    detachListener('zones')
  },
  setInventoryLots (state, lots) {
    state.inventoryLots = Array.isArray(lots) ? lots : []
    state.inventoryLotsLoaded = true
  },
  clearInventoryLots (state) {
    state.inventoryLots = []
    state.inventoryLotsLoaded = false
  }
}
